import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useTrackAccountMenuClick = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const trackAccountMenuClickEvent = useCallback(
    (menuTitle) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }
      if (window.webengage) {
        if (menuTitle?.trim() !== "") {
          window.webengage.track("account_menu_clicked", {
            menuTitle,
          });
        }
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { trackAccountMenuClickEvent };
};

export default useTrackAccountMenuClick;
